import React, { useEffect } from "react";
import { GlobalStyle } from "../../components/commons/Commons.style";
import Footer from "../../components/footer/Footer";
import NavigationBar from "../../components/navigationBar/NavigationBar";
import IFooter from "../../models/IFooter";
import { IGlobalPageComponents } from "../../models/IGlobalPageComponents";
import INavigationBar from "../../models/INavigationBar";
import { DialogProvider } from "../../providers/DialogProviders";
import { initGTag } from "../../utils/gtag";
import { PageLayoutStyle, MainContentContainerStyle } from "./Layout.style";

interface LayoutProps extends IGlobalPageComponents {
  children: React.ReactNode;
  navigationBar: INavigationBar;
  footer: IFooter;
}

const Layout = ({ children, navigationBar, footer }: LayoutProps) => {
  useEffect(() => {
    initGTag();
  }, []);

  return (
    <PageLayoutStyle>
      <GlobalStyle />
      <DialogProvider>
        <NavigationBar
          primaryLinks={navigationBar.primaryLinks}
          secondaryLinks={navigationBar.secondaryLinks}
        />
        <MainContentContainerStyle>{children}</MainContentContainerStyle>
        <Footer links={footer.links} />
      </DialogProvider>
    </PageLayoutStyle>
  );
};

export default Layout;
